import EditIcon from '@mui/icons-material/Edit';
import { Alert, Button, Step, StepContent, StepLabel, Tooltip, Typography, type AlertColor } from '@mui/material';
import React from 'react';

type StepAlert = {
  condition: boolean;
  text: string;
  severity: AlertColor;
}
type StepTemplateProps = {
  isStepCompleted: boolean;
  isLocked: boolean;
  label: string;
  editText: string;
  onEditClick: () => void
  children: React.ReactNode; // Acts as the contents of the step.
  alerts?: StepAlert[];
  tooltipText?: string;
}

const StepTemplate = ({
  isStepCompleted,
  isLocked,
  label,
  editText,
  tooltipText,
  onEditClick,
  children,
  alerts,
  ...otherProps
} : StepTemplateProps) => {
  const renderEditButton = () => {
    // Span is used because tooltip cannot be applied to "disabled" Buttons.
    // In our scenarios, the tooltip is needed exactly for when they are disabled.
    return (
      <span>
        <Button
          variant='outlined'
          onClick={() => {
            onEditClick();
          }}
          endIcon={!isLocked && <EditIcon />}
          disabled={isLocked}
          fullWidth
          sx={{
            justifyContent: 'space-between',
            maxWidth: '400px',
          }}
        >
          <Typography
            component='span'
            noWrap
            sx={{
              minWidth: 0,
              overflow: 'hidden',
              textAlign: 'left',
            }}
          >
            {editText}
          </Typography>
        </Button>
      </span>
    );
  };

  const shouldShowTooltip = isLocked && tooltipText;

  return (
    <Step {...otherProps}>
      <StepLabel>
        {isStepCompleted ? shouldShowTooltip ? (
          <Tooltip placement='right' title={tooltipText}>
            {renderEditButton()}
          </Tooltip>
        ) : renderEditButton() : label}
        {alerts?.map((alert: StepAlert, index: number) => alert.condition ? <Alert key={index} severity={alert.severity} sx={{ mt: 0.5 }}>{alert.text}</Alert> : null)}
      </StepLabel>
      <StepContent>
        {children}
      </StepContent>
    </Step>
  );
};

export default StepTemplate;
